import JmPayContainer from './JmPayContainer';
export default JmPayContainer;
